module.exports = __webpack_public_path__ + "img/right_arrow.d6b4d805.png";